<div [style.background]="opacity ? 'rgba(254,254,254, 0.6)' : ''" class="header-container">
	<div class="container">
	<div class="logo-container"> 
	  <a class="logo" [routerLink]="['/channel']" ><img  class="logoBig"  src="assets/logo.png"/> <img  class="logoMin"  src="assets/logo_min.png"/></a>
	</div>

	<div *ngIf="searchBar" class="search">
		 
		<nb-form-field>
			<input #searchInput [(ngModel)]="searchText" (keyup.enter)="search()"  class="searchInput" placeholder="Пошук" fieldSize="small" nbInput>
			<button (click)="search()" class="searchButton" size="small" nbSuffix nbButton  >
			  <nb-icon [icon]="'search-outline'" pack="eva" ></nb-icon>
			</button>
		  </nb-form-field>
		 

		<button style="margin-left:5px" (click)="cancelSearch()" *ngIf="searchMode" size="small" nbSuffix nbButton  >
			  <nb-icon [icon]="'close-outline'" pack="eva" ></nb-icon>
			</button>
		 
	</div>

 
   <!--  <nb-select [selected]="currentTheme" (selectedChange)="changeTheme($event)" status="primary">
	  <nb-option *ngFor="let theme of themes" [value]="theme.value"> {{ theme.name }}</nb-option>
	</nb-select> -->
	<div class="login">
		<button [routerLink]="['/login']"   nbButton size="small" status="primary">Створити канал</button>
	</div>

	<div  [style.marginLeft]="searchBar ? '' : 'auto'"  class="login-mob">
		<button [routerLink]="['/login']"   nbButton size="small" status="primary"> <nb-icon [icon]="'log-in-outline'" pack="eva" ></nb-icon></button>
	</div>
	<div>


  </div>
  
   
